var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pic-tree"},_vm._l((_vm.nodes),function(node){return _c('PICTreeItem',{key:node.id,attrs:{"node":node,"highlight-ids":_vm.highlightIds,"selected-id":_vm.selectedId},on:{"select":_vm.onSelect}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }